// extracted by mini-css-extract-plugin
export default {"item":"CartItem_item__EURFe","imgDiv":"CartItem_imgDiv__uu6K2","infos":"CartItem_infos__DTJP-","price":"CartItem_price__ZNYB4","btn":"CartItem_btn__Q5vHe"};